import React from 'react'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import Button from '@material-ui/core/Button'
import MoreHoriz from '@material-ui/icons/MoreHoriz'
import Close from '@material-ui/icons/Close'
import CircularProgress from '@material-ui/core/CircularProgress'
import PatientCareIcon from '../../Icons/tags/PatientCareIcon'
import { useStyles } from '../styles'
import { AUDIO_TYPE, TEXT_TYPE, VIDEO_TYPE, TAG_ICONS_COMPONENTS_MAP } from '../../../constants/story'

const MODAL_BACKGROUND_COLOR_MAP = {
  [TEXT_TYPE]: '#FCF9F8',
  [VIDEO_TYPE]: '#161515',
  [AUDIO_TYPE]: '#8688A1'
}

const MODAL_DETAILS_COLOR_MAP = {
  [TEXT_TYPE]: 'rgba(134, 136, 161, 0.1)',
  [VIDEO_TYPE]: 'rgba(255,255,255, 0.1)',
  [AUDIO_TYPE]: 'rgba(145, 147, 170, 0.9)'
}

const StoryCardModal = ({
  resourceType,
  isModalOpen,
  handleModalClose,
  isLinkSigning,
  presignedFileLink,
  name,
  textCardContent,
  dateCreated,
  tags,
  user
}) => {
  const [isDetailsOpen, setDetailsOpen] = React.useState(false)
  const classes = useStyles()

  const handleDetailsOpen = () => {
    setDetailsOpen(true)
  }

  const handleDetailsClose = () => {
    setDetailsOpen(false)
  }

  const closeModal = () => {
    handleDetailsClose()
    handleModalClose()
  }

  return (
    <Modal
      className={classes.modal}
      open={isModalOpen}
      onClose={closeModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={isModalOpen}>
        <div className={classes.modalWrapper} style={{ backgroundColor: MODAL_BACKGROUND_COLOR_MAP[resourceType] }}>
          {isLinkSigning ? (
            <div className={classes.loader} style={{ color: resourceType === TEXT_TYPE ? '#8688A1' : '#FFF' }}>
              <CircularProgress color='inherit' />
            </div>
          ) : (
            <>
              {isDetailsOpen && (
                <Fade in={isDetailsOpen}>
                  <div
                    className={classes.cardDetails}
                    style={{
                      backgroundColor: MODAL_DETAILS_COLOR_MAP[resourceType]
                    }}
                  >
                    <Button
                      onClick={handleDetailsClose}
                      className={classes.cardDetailsCloseButton}
                      style={
                        resourceType === TEXT_TYPE
                          ? { border: '1px solid #000', color: '#000' }
                          : { border: '1px solid #FFF', color: '#FFF' }
                      }
                    >
                      <Close />
                    </Button>
                    <div className={classes.cardDetailsInformationBlock}>
                      <Typography
                        variant='h6'
                        component='div'
                        className={resourceType === AUDIO_TYPE ? classes.delailsLabelAudio : classes.delailsLabel}
                      >
                        TAGGED WITH
                      </Typography>
                      {tags.map(tag => {
                        const TagIconComponent = TAG_ICONS_COMPONENTS_MAP[tag.name] || PatientCareIcon
                        return (
                          <div key={tag.id} className={classes.cardDetailsTagValue}>
                            <TagIconComponent size={36} key={tag.id} fillColor={resourceType === TEXT_TYPE ? '#000' : '#FFF'} />
                            <Typography
                              variant='h5'
                              component='div'
                              className={resourceType === TEXT_TYPE ? classes.detailsValueText : classes.detailsValue}
                            >
                              {tag.name}
                            </Typography>
                          </div>
                        )
                      })}
                    </div>
                    <div className={classes.cardDetailsInformationBlock}>
                      <Typography
                        variant='h6'
                        component='div'
                        className={resourceType === AUDIO_TYPE ? classes.delailsLabelAudio : classes.delailsLabel}
                      >
                        LEARNER NAME
                      </Typography>
                      <Typography
                        variant='h5'
                        component='div'
                        className={resourceType === TEXT_TYPE ? classes.detailsValueText : classes.detailsValue}
                      >
                        {user && `${user.firstName} ${user.lastName}`}
                      </Typography>
                    </div>
                    {user.waves && user.waves.length ? (
                      <div className={classes.cardDetailsInformationBlock}>
                        <Typography
                          variant='h6'
                          component='div'
                          className={resourceType === AUDIO_TYPE ? classes.delailsLabelAudio : classes.delailsLabel}
                        >
                          WAVE
                        </Typography>
                        <Typography
                          variant='h5'
                          component='div'
                          className={resourceType === TEXT_TYPE ? classes.detailsValueText : classes.detailsValue}
                        >
                          {user.waves[0].name}
                        </Typography>
                      </div>
                    ) : null}
                    <div className={classes.cardDetailsInformationBlock}>
                      <Typography
                        variant='h6'
                        component='div'
                        className={resourceType === AUDIO_TYPE ? classes.delailsLabelAudio : classes.delailsLabel}
                      >
                        STORY TITLE
                      </Typography>
                      <Typography
                        variant='h5'
                        component='div'
                        className={resourceType === TEXT_TYPE ? classes.detailsValueText : classes.detailsValue}
                      >
                        {name}
                      </Typography>
                    </div>
                    <div className={classes.cardDetailsInformationBlock}>
                      <Typography
                        variant='h6'
                        component='div'
                        className={resourceType === AUDIO_TYPE ? classes.delailsLabelAudio : classes.delailsLabel}
                      >
                        CAPTURED ON
                      </Typography>
                      <Typography
                        variant='h5'
                        component='div'
                        className={resourceType === TEXT_TYPE ? classes.detailsValueText : classes.detailsValue}
                      >
                        {new Date(dateCreated).toLocaleDateString()}
                      </Typography>
                    </div>
                  </div>
                </Fade>
              )}
              <div className={classes.modalBody}>
                <div className={classes.modalHeader}>
                  {!isDetailsOpen && (
                    <Button
                      onClick={handleDetailsOpen}
                      className={classes.cardDetailsButton}
                      style={
                        resourceType === TEXT_TYPE
                          ? { border: '1px solid #000', color: '#000' }
                          : { border: '1px solid #FFF', color: '#FFF' }
                      }
                    >
                      <MoreHoriz />
                    </Button>
                  )}
                  <Button
                    onClick={closeModal}
                    variant='outlined'
                    className={classes.closeModalButton}
                    style={
                      resourceType === TEXT_TYPE
                        ? { border: '1px solid #8688A1', color: '#8688A1' }
                        : { border: '1px solid #FFF', color: '#FFF' }
                    }
                  >
                    CLOSE
                  </Button>
                </div>
                <div className={classes.modalContent}>
                  {resourceType === TEXT_TYPE ? (
                    <>
                      <Typography variant='h2' component='div' className={classes.contentHeader}>
                        {name}
                      </Typography>
                      <Typography variant='h3' component='div' className={classes.textCardContent}>
                        {textCardContent}
                      </Typography>
                    </>
                  ) : (
                    <CardMedia classes={{ root: classes.cardMediaContent }} src={presignedFileLink} component={resourceType} controls />
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </Fade>
    </Modal>
  )
}

export default StoryCardModal
